const validateGetAuthorisationDelegate = getAuthorisationDelegate => {
  if (typeof getAuthorisationDelegate !== "function") {
    throw new TypeError(
      "configuration.getAuthorisation is required for this operation, and should be a function"
    );
  }
};

export default validateGetAuthorisationDelegate;
